// extracted by mini-css-extract-plugin
module.exports = {"exItem":"exhibition_exItem__1Unvx"};